module.exports = __webpack_public_path__ + "static/media/laravel.41946e11.png";